<template>

    <div v-loading="loading">

        <el-row>
            <el-col :span="12">
                <el-row :gutter="20">
                    <el-col :span="24" >
                        <h4>
                            首页标签 ({{ home_tags.length}}/30)

                            <el-link type="primary" class="fright" @click.native="clearAll">全部清除</el-link>
                        </h4>

                        <div class="tag_container">
                            <el-tag v-for="tag in home_tags" :key="tag.cate_id" data-cid="tag.cate_id"
                                :closable="true" effect="plain" :hit="true" @close="onHometagremove($event, tag)">{{tag.cate_name}}</el-tag>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <h4>历史标签</h4>

                        <div class="tag_container">
                            <el-tag v-for="tag in history_tags" :key="tag.cate_id" @click="onOtherTagClick( $event, tag)"
                                effect="dark" :hit="true">{{tag.cate_name}}</el-tag>
                        </div>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="24">
                        <h4>全部标签</h4>

                        <el-row>
                            <el-col :span="8">
                                <el-input placeholder="输入后按回车搜索标签..." @change.native="onSearch" v-model="searchKey"></el-input>
                            </el-col>
                        </el-row>

                        <div class="tag_container">
                            <el-tag v-for="tag in total_show_tags" type="success" data-cid="tag.cate_id"
                                @click="onOtherTagClick( $event, tag)"
                                :key="tag.cate_id" effect="light" :hit="false" >{{tag.cate_name}}</el-tag>
                        </div>
                    </el-col>
                </el-row>

            </el-col>
        </el-row>

    </div>

</template>

<style>
    h4{
        margin: 10px auto;
        overflow: hidden;
    }
    .fright{
        float:  right;
    }

    .tag_container{
        margin: 10px auto;
        min-height: 100px;
    }
    .tag_container .el-tag{
        cursor: pointer;
        margin:  5px 5px;
    }
    .el-message-box.confirm_cls{
        width: 360px !important;
        min-width: 120px;
    }
</style>

<script>
import { BASE_URL } from "../../config/app";
import { tagAllList, addhometag, removehomtag} from "../../api/tagManager/index";
export default {
    data() {
        return {
            searchKey: "",
            // toExportUrl:BASE_URL+'admin/apply/apply/toExport',
            loading: true,

            // 首页标签最大个数
            home_max_count: 30,

            // 历史首页标签最大个数
            history_max_count: 20,

            home_tags: [],
            history_tags: [],
            total_tags: [],
            total_show_tags: []
        };
    },
    methods: {
        backHistory(){
            this.$router.go(-1);//返回上一层
        },

        confirm(msg, title){
            title = title || "";
            return this.$confirm( msg, title, {
                customClass: "confirm_cls"
            });
        },

        clearAll(){
            this.confirm( "确定要清除所有首页标签？")
                .then( () => {
                    removehomtag( {
                        cate_id: "all"
                    }).then( (res) => {
                        if( res.code == 200){
                            this.$succMsg( "清除成功");
                            // this.home_tags = [];
                            this.getHomeTags();
                        }else{
                            this.$errMsg( "清除失败" + res.msg);
                        }
                    })
                    .catch( () => {
                        this.$errMsg( "操作失败");
                    });
                });
        },
        onHometagremove( e, cate){
            this.confirm( "是否要将 " + cate.cate_name + " 从首页标签中去除？")
                .then( () => {
                    removehomtag( {
                        cate_id: cate.cate_id
                    }).then( (res) => {
                        if( res.code == 200){
                            this.$succMsg( "清除成功");
                            // this.home_tags = [];
                            this.getHomeTags();
                        }else{
                            this.$errMsg( "清除失败" + res.msg);
                        }
                    })
                    .catch( () => {
                        this.$errMsg( "操作失败");
                    });
                });
        },

        onSearch( e){
            console.log( e);

            var list = this.total_tags;

            if( this.searchKey.length > 0){
                list = [];
                this.total_tags.forEach( ( item) =>{
                    if( item.cate_name.indexOf( this.searchKey) >= 0){
                        list.push( item);
                    }
                });
            }
            this.total_show_tags = list;
        },

        // 将选中的标签设置为首页标签
        onOtherTagClick( e, cate){

            if( this.home_tags.length >= this.home_max_count){
                this.$errMsg( "最多只能添加" + this.home_max_count + "个首页标签");
                return;
            }

            var cate_id = cate.cate_id;
            var cate_name = cate.cate_name;
            var find = false;
            this.home_tags.forEach( ( item) =>{
                find = find || item.cate_id == cate_id;
            });

            // 不重复加入
            if (find ) {
                this.$errMsg( cate_name + "已是首页标签");
                return;
            }

            this.confirm( "是否要将 " + cate_name + " 加入到首页标签中？", "提示", {
            }).then( () => {
                console.log( "onOtherTagClick", e, cate_id);

                addhometag( {
                    cate_id: cate_id
                }).then( (res) => {
                    if( res.code == 200){
                        this.$succMsg( "添加成功");
                        this.getHomeTags();
                    }else{
                        this.$errMsg( "添加失败" + res.msg);
                    }
                });
            });
        },

        getHomeTags(){
            this.loading = true;
            tagAllList( {
                page: 1
            })
            .then( (res) => {
                var data = res.data.list || [];
                // console.log( "hometags", data);

                // 分析各种数据
                var home_list = [];
                var history_list = [];
                var total_list = [];

                data.forEach( ( item) => {
                    if( item.is_use == 1 && home_list.length < this.home_max_count){
                        home_list.push( item);
                    }
                    if( item.history_timestamp && history_list.length < this.history_max_count){
                        history_list.push( item);
                    }

                    total_list.push( item);
                });

                this.home_tags = home_list;
                this.history_tags = history_list;
                this.total_tags = total_list;
                this.total_show_tags = total_list;
                this.loading = false;

                // data.length = Math.min( this.home_max_count, data.length);
                // this.home_tags = data;
            })
            .catch( () => {
                this.$errMsg( "读取首页Tags失败");
            });
        },
    },
    filters: {
    },
    mounted() {},
    created( ) {
        sessionStorage.setItem( "currentPage_advertList", 1);
        sessionStorage.setItem( "currentPage_findVideoList", 1);
        sessionStorage.setItem( "currentPage_findList", 1);
        sessionStorage.setItem( "currentPage_messageList", 1);
        sessionStorage.setItem( "currentPage_normalUsersAdmin", 1);
        sessionStorage.setItem( "currentPage_userList", 1);
        sessionStorage.setItem( "currentPage_editorList", 1);
        this.getHomeTags();
    }
};
</script>
<style type="text/scss" lang="scss">
</style>
<style>
 .el-form-item__label{
     margin-top: 5px;
 }
</style>
